// import env from '@beam-australia/react-env';

// export const REACT_APP_API_HOST =  env('API_HOST');
export const REACT_APP_API_HOST =  "https://api.stage.satschel.com/v2/rocket";

